import { SidebarNavItem } from '@/components/layout/sidebar/SidebarNavItem'
import { NAV_ITEMS } from '@/config/sidebar'

interface SidebarNavigationMenuProps {
	onItemClick: () => void
}

export function SidebarNavigationMenu({ onItemClick }: SidebarNavigationMenuProps) {
	return (
		<nav className='mt-4 flex flex-col gap-1'>
			{NAV_ITEMS.map(({ key, label, icon, to }) => (
				<SidebarNavItem key={key} to={to} label={label} icon={icon} onClick={onItemClick} />
			))}
		</nav>
	)
}
